export const ENTITY_PER_PAGE = 10;
export const PROP_NAME_CITY = "city";
export const PROP_NAME_PRODUCT_CATEGORY = "categories";
export const PROP_NAME_INPUT_TEXT = "searchText";
export const PROP_NAME_STATUS = "status";
export const PROP_NAME_INSURANCE = "insurance";
export const PROP_NAME_TRANSACTIONS = "insurance";
export const PROP_NAME_METHOD = "method";
export const PROP_NAME_PURPOSE = "purpose";
export const PROP_NAME_SORTBY = "sortBy";
export const PROP_NAME_SKIP_ADS = "skipAds";
export const PROP_NAME_FROM_DATE = "fromDate";
export const PROP_NAME_FROM_DATE_SEARCH_MAIN = "fromDateMain";
export const PROP_NAME_TO_DATE_SEARCH_MAIN = "toDateMain";
export const PROP_NAME_TO_DATE = "toDate";
export const PROP_NAME_IS_RENTER = "isRenter";
export const PROP_NAME_MAIN_TAB = "mainTab";
export const PROP_NAME_NEXT_TAB = "nextTab";
export const PROP_NAME_CHOOSEN_USER_CHAT_ID = "choosenChatUserId";
export const PROP_NAME_CHOOSEN_CHAT_ID = "choosenChatId";
export const PROP_NAME_REQUEST_CHATS = "requestChats";
export const PROP_NAME_BLOCKED = "isBlocked";
export const PROPS_NAME_IS_NEW = "isNew";
export const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;
// Extension listed too: browsers often report an empty MIME type for HEIC files
export const HEIC_ACCEPT = "image/heic,.heic";
export const PURPOSE_OPTIONS = {
  USER_TO_SERVICE: "Rent",
  USER_TO_SERVICE_DEBT: "Debt",
  SERVICE_TO_LESSOR: "Payout",
  FREEZE_AMOUNT: "Freeze",
  UNFREEZE_AMOUNT: "Unfreeze",
  TOKEN_BURN: "Burn",
  SERVICE_TO_USER_REFUND_RENTAL: "Refund Rent",
  SERVICE_TO_USER_REFUND_INSURANCE: "Refund Insurance",
  COUNTRY_TO_INSURANCE_TRANSFER: "Insurance Transfer",
  INSURANCE_TO_COUNTRY_TRANSFER: "Insurance Return",
  SERVICE_DEBT_REPAYMENT: "Debt Repayment",
};

export const PURPOSE_OPTIONS_V2 = {
  RentalAndInsurance: "Rental & Insurance",
  RentalAndDeposit: "Rental & Deposit",
  Rent: "Rental",
  Deposit: "Deposit",
  Debt: "Debt",
  Insurance: "Insurance",
  CardLink: "Card Link",
  Referral: "Referral",
  DepositUnhold: "Deposit Unhold",
  DepositHold: "Deposit Hold",
  Refund: "Refund",
};

export enum GetPurposeCategoryEnum {
  RentalAndInsurance = "RentalAndInsurance", // транзы вида USER_TO_SERVICE/SERVICE_TO_LESSOR если у транзы была страховка оплата картой/кошельком
  RentalAndDeposit = "RentalAndDeposit", // транзы вида USER_TO_SERVICE/SERVICE_TO_LESSOR если у транзы был депозит оплата картой
  Rent = "Rent", // транзы вида USER_TO_SERVICE/SERVICE_TO_LESSOR если транза с оплатой по кошельку + депозит а также транзы SERVICE_TO_USER_REFUND_RENTAL
  Deposit = "Deposit", // транзы вида FREEZE_AMOUNT/UNFREEZE_AMOUNT
  Debt = "Debt", // транзы вида USER_TO_SERVICE_DEBT/SERVICE_DEBT_REPAYMENT
  Insurance = "Insurance", // SERVICE_TO_USER_REFUND_INSURANCE
  CardLink = "CardLink", // binding
  Referral = "Referral",
  DepositUnhold = "DepositUnhold",
  DepositHold = "DepositHold",
  Refund = "Refund",
}
